import React from "react";

import { useParams } from "react-router";

import {
  DETAILS_PAGES,
  DetailsPageProps,
  getDetailPageType,
} from "@companion-core/shared/app/Components/DetailsPages/DetailsPage.model";
import { useConfigStore } from "@companion-core/shared/app/Store/configStore";

export const DetailsPage: React.FC<DetailsPageProps> = () => {
  const { contentType, id, origin } = useParams();
  const { config } = useConfigStore();

  const DetailPage = !contentType
    ? getDetailPageType(origin ?? "", config?.options?.editorialContent)
    : DETAILS_PAGES[contentType ?? ""];

  return <DetailPage id={id ?? ""} origin={origin} contentType={contentType ?? ""} />;
};
